"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function upgradeBookingData(data, node, isBooked) {
    return {
        data: data,
        isBooked: isBooked,
        node: node,
        type: 'V16/booking_widget/upgrade_data',
    };
}
exports.upgradeBookingData = upgradeBookingData;
exports.initialBookingWidgetState = {
    // tslint:disable-next-line:no-object-literal-type-assertion
    context: {},
    isBooked: null,
    node: null,
    offer: null,
};
function bookingWidgetReducer(state, action) {
    if (state === void 0) { state = exports.initialBookingWidgetState; }
    switch (action.type) {
        case 'V16/booking_widget/upgrade_data':
            return tslib_1.__assign({}, state, { isBooked: action.isBooked, node: action.node, offer: action.data });
        default:
            return state;
    }
}
exports.bookingWidgetReducer = bookingWidgetReducer;



//////////////////
// WEBPACK FOOTER
// ./src/shared/booking_widget/state.ts
// module id = 103
// module chunks = 2